/* KK30 Black Friday page (Figma KK-30, 2026-10-08).
   - moves the "BLACK FRIDAY | BUY 1 GET 1 FREE" bar from the buy box to the
     top of the page (above the header group), then runs confetti on it */
(function () {
  'use strict';

  function placeBanner() {
    var banner = document.querySelector('[data-kk30-banner]');
    if (!banner) return null;
    var header = document.getElementById('shopify-section-group-header-group')
      || document.querySelector('.shopify-section-group-header-group');
    var target = header || document.getElementById('MainContent');
    if (target && target.parentNode && banner.nextElementSibling !== target) {
      target.parentNode.insertBefore(banner, target);
    }
    banner.removeAttribute('hidden');
    return banner;
  }

  /* Confetti: small tilted rectangles drifting down across the bar, looping.
     Gold / white / orange on the black half, white / black on the gold half
     read fine, so one palette is used for the whole bar. */
  function confetti(banner) {
    var canvas = banner.querySelector('.kk30-banner__confetti');
    if (!canvas || !canvas.getContext) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ctx = canvas.getContext('2d');
    var colors = ['#FFD24D', '#FFFFFF', '#FF8A00', '#F7C948', '#FFF3C4'];
    var pieces = [];
    var width = 0, height = 0, dpr = 1, raf = 0, running = false, last = 0;

    function resize() {
      var rect = banner.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = Math.max(1, Math.round(rect.width));
      height = Math.max(1, Math.round(rect.height));
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var count = Math.round(Math.min(70, Math.max(24, width / 14)));
      while (pieces.length < count) pieces.push(spawn(true));
      pieces.length = count;
    }

    function spawn(anywhere) {
      var size = 3 + Math.random() * 5;
      return {
        x: Math.random() * width,
        y: anywhere ? Math.random() * height : -size * 2,
        w: size,
        h: size * (0.5 + Math.random() * 0.7),
        vy: 18 + Math.random() * 26,          // px / s
        vx: (Math.random() - 0.5) * 14,
        sway: Math.random() * Math.PI * 2,
        swaySpeed: 1.2 + Math.random() * 1.6,
        rot: Math.random() * Math.PI,
        rotSpeed: (Math.random() - 0.5) * 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 0.75 + Math.random() * 0.25
      };
    }

    function frame(now) {
      if (!running) return;
      var dt = Math.min(0.05, (now - (last || now)) / 1000);
      last = now;
      ctx.clearRect(0, 0, width, height);
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.sway += p.swaySpeed * dt;
        p.y += p.vy * dt;
        p.x += (p.vx + Math.sin(p.sway) * 10) * dt;
        p.rot += p.rotSpeed * dt;
        if (p.y > height + p.h * 2 || p.x < -20 || p.x > width + 20) pieces[i] = p = spawn(false);
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      running = true; last = 0;
      raf = window.requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      if (raf) window.cancelAnimationFrame(raf);
      raf = 0;
    }

    resize();
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0 }).observe(banner);
    } else {
      start();
    }
  }

  function init() {
    var banner = placeBanner();
    if (banner && !banner.dataset.kk30Confetti) {
      banner.dataset.kk30Confetti = '1';
      confetti(banner);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders the section; re-place the (new) banner.
  document.addEventListener('shopify:section:load', init);
})();
